"use strict";

function getParitialVisibilityGutter(responsive, partialVisbile, serverSideDeviceType, clientSideDeviceType) {
  var gutter = 0,
      deviceType = clientSideDeviceType || serverSideDeviceType;
  return partialVisbile && deviceType && (gutter = responsive[deviceType].paritialVisibilityGutter), gutter;
}

function getWidthFromDeviceType(deviceType, responsive) {
  var itemWidth;
  responsive[deviceType] && (itemWidth = (100 / responsive[deviceType].items).toFixed(1));
  return itemWidth;
}

function getItemClientSideWidth(props, slidesToShow, containerWidth) {
  return containerWidth / (slidesToShow + (props.centerMode ? 1 : 0));
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getParitialVisibilityGutter = getParitialVisibilityGutter, exports.getWidthFromDeviceType = getWidthFromDeviceType, exports.getItemClientSideWidth = getItemClientSideWidth;